const senslaScoreText = (values: any[]) => {
  if (!values.length) {
    return '';
  }
  let firstInsight = '';
  // let secondInsight = '';
  // let thirdInsight = '';

  const lastValues = values.length
    ? [
        { key: 'energy', value: values[values.length - 1].energy },
        { key: 'efficacy', value: values[values.length - 1].efficacy },
        { key: 'constancy', value: values[values.length - 1].constancy },
      ].sort((m1: any, m2: any) => m1.value - m2.value)
    : [];

  if (values[values.length - 1].senslaScore < 0.4) {
    firstInsight = `Currently your team or channel is not showing a good performance due to Sensla Score is below to 40% (${(
      values[values.length - 1].senslaScore * 100
    ).toFixed(1)}%). This behavior is reflected mainly in the ${
      lastValues[0].key === 'efficacy' && lastValues[0].value === 0
        ? lastValues[1].key
        : lastValues[0].key
    } of your team.`;
  } else if (values[values.length - 1].senslaScore < 0.7) {
    firstInsight = `Your team is showing good performance, however some metrics can be improved with simple adjustment that can help your team grow. The pillar that is showing less value is ${lastValues[0].key} of your team.`;
  } else {
    firstInsight =
      'Your team is in excellent conditions, the participation, the fluid conversation and the good sentiment are part of it, keep them motivated.';
  }

  // const difference =
  //   (values[values.length - 1].senslaScore - values[0].senslaScore) / values[0].senslaScore;
  // if (difference < 0.2 && difference > -0.2) {
  //   secondInsight =
  //     'During the last 4 weeks the difference has been maintain below the 20%. This indicates that is a normal behavior of the team but you can improve the metrics associated to it.';
  // } else if (difference < -0.2) {
  //   secondInsight =
  //     'Also, you should be aware that this team or channel has had a very strong decline from a month ago to date.';
  // } else {
  //   secondInsight =
  //     'Regarding the performance in the time, the improvement is remarkable during these last 4 weeks, check what actions have been implemented that are achieving remarkable changes.';
  // }

  // if (values[values.length - 1].efficacy === 0) {
  //   thirdInsight =
  //     'Some times when your team does not show Efficacy Metric (zero) is when we do not have enough input to show you a correct score, so we only use Energy and Constancy to calculate the Sensla Score';
  // }

  // return `${firstInsight} ${secondInsight} ${thirdInsight}`;
  return `${firstInsight}`;
};

const energyText = (values: any[]) => {
  if (!values.length) {
    return '';
  }
  let firstInsight = '';
  // let secondInsight = '';

  if (values[values.length - 1].y < 0.4) {
    firstInsight = `The energy of your workspace or your channel is too low, (${(
      values[values.length - 1].y * 100
    ).toFixed(
      1
    )}%). You must generate dynamics that allow you to increase positive participation in the channel. If this does not improve perhaps one on one would be a good recommendation to understand the situation of the team, if this is not a normal behavior of the team.`;
  } else if (values[values.length - 1].y < 0.7) {
    firstInsight = `The team has a good energy. It has opportunities for improvement, but remains at a good standard. Active listening to employees can give you ideas on how to improve the positive participation of team members. They usually have good ideas.`;
  } else {
    firstInsight =
      'The energy of your team is wonderful. Now the most important thing is to keep this energy at those levels, it will help the work to flow, to have more synergy in the team and social interaction that is a hook between collaborators.';
  }

  // if (values[values.length - 1].y / values[values.length - 2].y - 1 < -0.1) {
  //   secondInsight = `Try to be aware that the last week had a decrease of more than 10% (${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }%).`;
  // } else if (values[values.length - 1].y / values[values.length - 2].y - 1 > 0.1) {
  //   secondInsight = `Excellent, this week there was an improvement of ${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }%. Maintain your team with these weekly improvements.`;
  // }

  // return `${firstInsight} ${secondInsight}`;
  return `${firstInsight}`;
};

const efficacyText = (values: any[]) => {
  if (!values.length) {
    return '';
  }
  let firstInsight = '';
  // let secondInsight = '';

  if (values[values.length - 1].y < 0.4) {
    firstInsight = `${(values[values.length - 1].y * 100).toFixed(
      1
    )}% of efficacy in your workspace or your channel is really low. Empathy and teamwork are a reflection of these. Setting the example of responding in a timely manner can help improve this issue. If the team leader can corroborate this behavior, it is important to see the synergy of the team and seek help to dig deeper into the problem.`;
  } else if (values[values.length - 1].y < 0.7) {
    firstInsight = `The efficacy of the equipment is quite good. Through written communications, the team understands each other and meets the demands of the other collaborators. Improving this as much as possible can bring better communication and fluidity in the day-to-day work for the team.`;
  } else {
    firstInsight =
      'It is remarkable how the team understands each other, responds at all times and in a very timely manner. Keep making this type of practice a habit, set an example and each one of your people will adopt it for themselves.';
  }

  // if (values[values.length - 1].y / values[values.length - 2].y - 1 < -0.1) {
  //   secondInsight = `Try to be aware that the last week had a decrease of more than 10% (${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }%).`;
  // } else if (values[values.length - 1].y / values[values.length - 2].y - 1 > 0.1) {
  //   secondInsight = `Excellent, this week there was an improvement of ${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }%. Maintain your team with these weekly improvements regarding Efficacy.`;
  // }

  // return `${secondInsight} ${firstInsight}`;
  return `${firstInsight}`;
};

const constancyText = (values: any[]) => {
  if (!values.length) {
    return '';
  }
  let firstInsight = '';
  // let secondInsight = '';

  if (values[values.length - 1].y < 0.4) {
    firstInsight = `Consistency is not being part of the good communicational performance (${(
      values[values.length - 1].y * 100
    ).toFixed(
      1
    )}%). The daily participation is part of growing the team interaction according to the nature of each communication channel. Daily greetings, daily meetings, news can help improve this metric.`;
  } else if (values[values.length - 1].y < 0.7) {
    firstInsight = `Consistency is very healthy. Most of the team members interact on a daily basis making the work and distracting conversation flow. Encourage pleasant conversations, let others talk and make basic interactions part of the channel.`;
  } else {
    firstInsight =
      'Consistency is at a very good level. The members of the channel interact on a daily basis and this participation is encouraged in a good way. This should continue where everyone is part of the daily conversation.';
  }

  // if (values[values.length - 1].y / values[values.length - 2].y - 1 < -0.1) {
  //   secondInsight = `The difference in the last 2 weeks was more than 2 digits (${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }%). Don't be careless with this metric.`;
  // } else if (values[values.length - 1].y / values[values.length - 2].y - 1 > 0.1) {
  //   secondInsight = `Amazing, ${
  //     values[values.length - 2].y > 0
  //       ? (100 * (values[values.length - 1].y / values[values.length - 2].y - 1)).toFixed(1)
  //       : 100
  //   }% was the increase over the last two weeks with respect to constancy.`;
  // }

  // return `${firstInsight} ${secondInsight}`;
  return `${firstInsight}`;
};
export { senslaScoreText, energyText, efficacyText, constancyText };
